import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import { isOneDriveProScope, isOneDriveConsumerScope } from './utils/typeGuards';

export default {
    FPShowFilePicker: {
        name: 'FPShowFilePicker',
        options: { isCore: true, isCosmosDatapoint: true },
    },
    // This is used to store an action datapoint with customData, so the customData parameters must match the parameters of the action it is tracking.
    FPGetItems: {
        name: 'FPGetItems',
        customData: (
            providerType: AttachmentDataProviderType,
            providerId: any,
            offset: any,
            filterBy: AttachmentItemsFilterBy,
            scope: AttachmentDataProviderScope,
            fileProviderEndpointUrl?: any,
            folderId?: any,
            location?: any,
            pagingMetadata?: any,
            sort?: any
        ) => [providerType, scope.__type, getScopeType(scope)],
    },
    FPSearchItems: {
        name: 'FPSearchItems',
        customData: (
            fileProviderType: AttachmentDataProviderType,
            fileProviderId: string,
            searchQuery: string,
            offset?: number,
            folderId?: string,
            location?: string,
            pagingMetadata?: any,
            sort?: any
        ) => [fileProviderType],
    },
};

function getScopeType(scope: AttachmentDataProviderScope): number {
    if (isOneDriveProScope(scope) || isOneDriveConsumerScope(scope)) {
        return scope.Type;
    }

    // Default scope for Files/Root Items
    return 0;
}
